var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBlockSites = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    fillRule: "evenodd",
    d: "M15 10a5 5 0 1 0 0-10 5 5 0 0 0 0 10m0-1.667a3.333 3.333 0 0 0 2.902-4.974L13.36 7.902a3.3 3.3 0 0 0 1.64.431m1.745-6.173L12.16 6.745a3.333 3.333 0 0 1 4.586-4.586M2.667 1.667a1 1 0 0 0-1 1v4.666a1 1 0 0 0 1 1h4.666a1 1 0 0 0 1-1V2.667a1 1 0 0 0-1-1zm9 11a1 1 0 0 1 1-1h4.666a1 1 0 0 1 1 1v4.666a1 1 0 0 1-1 1h-4.666a1 1 0 0 1-1-1zm-9-1a1 1 0 0 0-1 1v4.666a1 1 0 0 0 1 1h4.666a1 1 0 0 0 1-1v-4.666a1 1 0 0 0-1-1z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBlockSites);
export { ForwardRef as ReactComponent };